/**
 * @author lifei
 * 模块说明：登录管理
 */

import { Service } from '@/tools'

export class LoginService<T extends TUser.Login> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.Login}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  doLogin = <K extends T['ApiDoLogin']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDoLogin', data, '登录成功')

  /**
   * 功能：注销
   * /api/user/login/logout
   */
  logout = <K extends T['ApiLogout']>(): Promise<K['res']> => this.post2('v1/ApiLogout')

  /**
   * 功能：获取用户基本信息
   * /api/user/login/getInfo
   */
  // /api/user/login/getInfo
  getInfo = <K extends T['ApiGetInfo']>(): Promise<K['res']> => this.post2('v1/ApiGetInfo')

  /**
   * 功能：切换组织
   * /api/user/login/switchOrg
   */
  switchOrg = <K extends T['ApiSwitchOrg']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSwitchOrg', data, '操作成功')
}
